import React, { FC, useEffect } from "react";
import { createUseStyles } from "react-jss";
import styles from "./styles";
import { LOCATION_MODULES } from "../../constants";

interface Props {
  isCif: boolean;
  closeModal?: () => void; // gets injected from the Modal HOC //
  onFormCompleted?: () => void;
  onPersonalizationCompleted?: () => void;
  locId: string | number;
  instId: string | number;
  tourId: string;
  typeId: string;
  userKey: string | number;
  sessionId: string | number;
  token: string;
  isAppilyAuth: boolean;
}

const CIF: FC<Props> = (props: Props) => {
  const {
    isCif,
    instId,
    locId,
    tourId,
    typeId,
    userKey,
    sessionId,
    token,
    closeModal,
    onFormCompleted,
    onPersonalizationCompleted,
    isAppilyAuth,
  } = props;

  // Styles //
  const useStyles = createUseStyles(styles);
  const classes = useStyles(styles);

  // legacy form url //
  const legacyForm = `${process.env.REACT_APP_API_BASE_URL}/registration/${instId}/${locId}?tourid=${tourId}&isMap=1&?typeid=${typeId}`;

  // cif url //
  const cifForm = `${
    process.env.REACT_APP_API_BASE_URL
  }registration-app/latest/index.html#/${instId}/${locId}?cif=1&inst_id=${instId}&loc_id=${locId}&tourid=${tourId}&userkey=${userKey}&source=web&original_source=web&sessionid=${sessionId}&embed=1&embed_type=virtual-tour&typeid=${typeId}&token=${token}&module_id=${
    LOCATION_MODULES.FULL_MAP
  }&mode=${isAppilyAuth ? "appily" : ""}`;

  // close form when it's completed //
  useEffect(() => {
    const regFormListener = (e) => {
      const formData = e.data;
      if (formData.message === "RegistrationForm_Completed") {
        onFormCompleted();
      } else if (formData.message === "RegistrationForm_Dismissed") {
        closeModal();
      }
      if ((formData?.message && formData?.message?.includes(":::personalization")) || formData.includes(":::personalization")) {
        onPersonalizationCompleted();
      }
    };

    window.addEventListener("message", regFormListener);
    return () => {
      window.removeEventListener("message", regFormListener);
    };
  }, [closeModal, onFormCompleted, onPersonalizationCompleted]);

  return (
    <iframe
      className={`${classes.iframeContainer} ${isCif ? "" : classes.legacy}`}
      title="Registration Form"
      src={isCif ? cifForm : legacyForm}
      data-testid="cif-form"
    />
  );
};

CIF.defaultProps = {
  closeModal: Function,
  onFormCompleted: Function,
  onPersonalizationCompleted: Function,
};

export default CIF;
try {
    // @ts-ignore
    CIF.displayName = "CIF";
    // @ts-ignore
    CIF.__docgenInfo = { "description": "", "displayName": "CIF", "props": { "isCif": { "defaultValue": null, "description": "", "name": "isCif", "required": true, "type": { "name": "boolean" } }, "closeModal": { "defaultValue": null, "description": "", "name": "closeModal", "required": false, "type": { "name": "() => void" } }, "onFormCompleted": { "defaultValue": null, "description": "", "name": "onFormCompleted", "required": false, "type": { "name": "() => void" } }, "onPersonalizationCompleted": { "defaultValue": null, "description": "", "name": "onPersonalizationCompleted", "required": false, "type": { "name": "() => void" } }, "locId": { "defaultValue": null, "description": "", "name": "locId", "required": true, "type": { "name": "ReactText" } }, "instId": { "defaultValue": null, "description": "", "name": "instId", "required": true, "type": { "name": "ReactText" } }, "tourId": { "defaultValue": null, "description": "", "name": "tourId", "required": true, "type": { "name": "string" } }, "typeId": { "defaultValue": null, "description": "", "name": "typeId", "required": true, "type": { "name": "string" } }, "userKey": { "defaultValue": null, "description": "", "name": "userKey", "required": true, "type": { "name": "ReactText" } }, "sessionId": { "defaultValue": null, "description": "", "name": "sessionId", "required": true, "type": { "name": "ReactText" } }, "token": { "defaultValue": null, "description": "", "name": "token", "required": true, "type": { "name": "string" } }, "isAppilyAuth": { "defaultValue": null, "description": "", "name": "isAppilyAuth", "required": true, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/CIF/CIF.tsx#CIF"] = { docgenInfo: CIF.__docgenInfo, name: "CIF", path: "src/shared/components/CIF/CIF.tsx#CIF" };
}
catch (__react_docgen_typescript_loader_error) { }